module.exports = __webpack_public_path__ + "static/img/BU04PB-2.c8eb43d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU04PB-2.jpg
// module id = DAsk
// module chunks = 1